<template>
    <article
            :class="{horizontal: horizontal, placeholder: placeholder}"
            class="movie"
            @click="horizontal = true"
            @mouseenter="horizontal = true"
            @mouseleave="horizontal = false"
    >
        <template v-if="model && model.webstar && !model.following">
          <div
              class="img locked"
              :style="cssVars"
          >
            <router-link
                class="lock"
                :to="{name: 'subscribe', query: {webstar: model.username}}"
            >
            </router-link>
            <template v-if="horizontal">
                <div
                    class="preview-wrapper active"
                >
                </div>
            </template>
            <span
                v-if="movie.is_hd"
                class="hd"
            >
                    HD
                  </span>
            <span
                v-if="movie.length"
                class="length"
            >
              {{movieLengthFormatted}}
            </span>
          </div>

          <div class="text">
            <h4 class="name">
              {{movie.name}}
            </h4>
          </div>
        </template>


        <template
            v-else-if="!placeholder"
        >
            <div
                    class="img"
                    :style="imgStyle"
            >
                <template v-if="horizontal">
                    <router-link
                            :to="{name: 'video.watch', params: {id: movie.id}}"
                    >
                        <div
                                class="preview-wrapper active"
                        >
                            <template>
                                <div
                                        class="preview"
                                        v-if="movie.public_thumbnail_video_path"
                                >
                                    <video
                                            disableRemotePlayback="false"
                                            ref="thumbnail_movie"
                                            width="100%"
                                            height="100%"
                                            autoplay="autoplay"
                                            loop="loop"
                                            :src="movie.public_thumbnail_video_path"
                                    ></video>
                                </div>
                                <div
                                        class="preview-unavailable"
                                        v-else
                                >
                                </div>
                            </template>
                        </div>
                    </router-link>
                </template>
                <span
                        v-if="movie.is_hd"
                        class="hd"
                >
                  HD
                </span>
                <span
                        v-if="movie.length"
                        class="length"
                >
                  {{movieLengthFormatted}}
                </span>
            </div>
            <div class="text">
                <h4 class="name">
                    {{movie.name}}
                </h4>
                <!--<p class="description">
                    {{movie.description}}
                </p>-->
            </div>
        </template>
        <template v-else>
            <div class="img"></div>
            <div class="text">
                <h4 class="name"></h4>
                <p class="description"></p>
            </div>
        </template>
    </article>
</template>
<script>
    export default {
        props: {
            movie: {
                type: Object,
                required: false,
                validate(value){
                    return value !== undefined || this.placeholder;
                }
            },
            placeholder: {
                type: Boolean,
                required: false,
                default: false
            },
            model: {
                type: Object,
                required: false,
                default: null
            }
        },
        data(){
            return {
                horizontal: false
            }
        },
        watch: {
            horizontal(value){
                if(value === true){

                    if(this.$refs.thumbnail_movie){
                        this.$refs.thumbnail_movie.currentTime = 0;
                        this.$refs.thumbnail_movie.play();
                    }

                    this.$emit('horizontal', );
                }
            }
        },
        computed: {
            movieLengthFormatted(){
                if(this.movie.length === null){
                    return null;
                }

                let videoDuration = (new Date(this.movie.length * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

                if (videoDuration.startsWith('00:')){
                    return videoDuration.substr(3, videoDuration.length);
                }else{
                    return videoDuration;
                }

            },
            imgStyle(){
                let image = (this.horizontal) ? this.movie.public_thumbnail_image_path['small'] : this.movie.public_thumbnail_image_path['small'];

                return {
                    backgroundImage: `url('${image}')`
                };
            },
            getImageBackgroundUrl(){
              return (this.horizontal) ? this.movie.public_thumbnail_image_path['small'] : this.movie.public_thumbnail_image_path['small'];
            },
          cssVars() {
            return {
              '--background': `url('${this.getImageBackgroundUrl}')`,
            }
          }
        }
    }
</script>
<style scoped lang="scss">
    @import '../styles/variables';

    .movie{
        flex-grow: 0;
        flex-basis: 0;
        padding-left: 5px;
        padding-right: 5px;
        transition: width .5s ease;
        max-width: calc(100vw - 20px);

        .img{
            //background-color: $pallete_secondary_color;
            background-color: #000000;
            position: relative;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            margin-bottom: .5em;
            height: 300px;
            transition: height .5s ease;

            span.hd{
                position: absolute;
                left: 5px;
                top: 5px;
                padding: 3px;
                font-weight: bold;
                border-radius: 2px;
                background-color: #000000;
                color: #ffffff;
            }

            span.length{
                position: absolute;
                right: 5px;
                bottom: 5px;
                padding: 3px;
                border-radius: 2px;
                font-size: 13px;
                background-color: #000000;
                color: #ffffff;
            }

            .preview-wrapper{
                opacity: 0;
                transition:opacity .30s linear;

                &.active{
                    opacity: 1;
                }
            }

            .preview-wrapper.active{

                .preview{
                    background-color: #000000;
                    position: absolute;
                    overflow: hidden;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    video{
                        /*object-fit: cover;*/
                        overflow:hidden;
                        min-width: 100%;
                        min-height: 100%;
                    }
                }

                .preview-unavailable{
                    position: absolute;
                    top:0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background-color: rgba(0,0,0,.25);
                }
            }
        }

        .text{
            text-align: left;

            .description{
                margin: 0;
                color: grey;
            }

            .name{
                margin: 0;
            }
        }

        &.placeholder{
            .img{
                background-color: rgba(128,128,128,.25);
            }

            .text{

                .description{
                    background-color: rgba(128,128,128,.25);
                    height: 1em;
                }

                .name{
                    background-color: rgba(128,128,128,.25);
                    height: 1em;
                }
            }
        }
    }

    .locked{
      z-index: 1;

      &:after{
        content: "";
        background: var(--background);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        opacity: 0.4;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: -1;
      }

      .lock{
        display: block;
        width: 100%;
        height: 100%;
        background-image: url('/img/lock.png');
        background-size: 100px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
</style>